export default {
  'translation.title': 'Language Management (Shared I18n)',
  'translation.guide.title': 'Classification & Naming Convention',
  'translation.guide.subtitle': 'Learn naming keys and using {dynamic} variables',
  'translation.guide.close': 'Click to collapse instruction content',
  'translation.guide.detail': 'VIEW DETAIL',
  'translation.guide.collapse': 'COLLAPSE',
  'translation.guide.groupTitle': 'GROUP CLASSIFICATION',
  'translation.guide.namingTitle': 'KEY NAMING CONVENTION',
  'translation.guide.namingExample': 'Example: home.banner.title, auth.login.submit_btn',
  'translation.guide.variableTitle': 'DYNAMIC SYSTEM VARIABLES',
  'translation.guide.variableNote': 'Note: Keep tags in curly braces when translating content.',
  'translation.guide.noVariable': 'No variables detected from DB',
  'translation.guide.systemVariable': 'System variable',
  'translation.tabs.all': 'All',
  'translation.tabs.missingVi': 'Missing Vietnamese',
  'translation.tabs.missingEn': 'Missing English',
  'translation.columns.key': 'Key',
  'translation.columns.group': 'Group',
  'translation.columns.description': 'Description / Context',
  'translation.columns.vi': 'Vietnamese (VI)',
  'translation.columns.en': 'English (EN)',
  'translation.columns.action': 'Actions',
  'translation.action.edit': 'Edit',
  'translation.action.delete': 'Delete',
  'translation.msg.syncSuccess': 'Cache synced successfully!',
  'translation.msg.syncFail': 'Sync failed',
  'translation.msg.deleteSuccess': 'Deleted successfully!',
  'translation.msg.deleteFail': 'Delete failed',
  'translation.msg.saveSuccess': 'Saved successfully!',
  'translation.msg.createSuccess': 'Added successfully!',
  'translation.msg.updateSuccess': 'Updated successfully!',
  'translation.msg.importSuccess': 'Imported {count} translations successfully!',
  'translation.msg.exportSuccess': 'Exported successfully!',
  'translation.msg.importFail': 'Import failed: {error}',
  'translation.msg.invalidFormat': 'Invalid file format (must be an array)',
  'translation.confirm.delete': 'Are you sure you want to delete this key?',
  'translation.confirm.permanentDelete': 'Are you absolutely sure you want to permanently delete this key?',
  'translation.drawer.editTitle': 'Translation Details',
  'translation.drawer.createTitle': 'Add New Key',
  'translation.drawer.statusTitle': 'Status',
  'translation.drawer.statusEditing': 'Editing existing translation',
  'translation.drawer.statusCreating': 'Creating new translation for the system',
  'translation.drawer.keyLabel': 'Translation Key (Identifier)',
  'translation.drawer.keyTooltip': 'Unique key used to retrieve the translation in code.',
  'translation.drawer.groupLabel': 'Group',
  'translation.drawer.contentSection': 'TRANSLATION CONTENT',
  'translation.drawer.noteSection': 'NOTES',
  'translation.drawer.deletePermanentBtn': 'Delete this translation from the system',
  'translation.toolbar.export': 'Export File',
  'translation.toolbar.import': 'Import File',
  'translation.toolbar.sync': 'Sync Cache',
  'translation.toolbar.add': 'Add New',
  'translation.search.search': 'Search',
  'translation.search.reset': 'Reset',
  'translation.search.expand': 'Expand Filters',
  'translation.search.collapse': 'Collapse',
  'translation.group.all': 'All',
  'translation.noDescription': 'No description available',
};
